<template>
  <div class="row column-s attendance">
    <div class="cards column grid-12-s" :class="openMap ? 'grid-5 opened' : 'grid-11 grid-12-s'">
      <div class="row wrap-m wrap-s align-end">
        <div class="title grid-4-g grid-12 row">
          <div class="grid-10 grid-11-m grid-11-s">
            <b>Acompanhamento</b>
            <br v-if="openMap" />
            <span>( {{ jobsFilter.length }} Jobs )</span>
          </div>
          <div class="filters-mobile hide-g" @click="filters = !filters">
            <i class="fa fa-filter"></i>
          </div>
        </div>

        <div :class="filters ? '' : 'hide-m hide-s'"
          class="row filters column-s grid-12-s grid-8-g grid-12-m justify-end">
          <!-- <div class="search fa">
            <input type="text" placeholder="Buscar" v-model="search" />
          </div> -->

          <div class="row column-s hide-g hide-m">
            <div class="grid-12 column">
              <label for="etapa">Etapa</label>
              <select class="input" @change="attendance({ etapa: filter.etapa })" v-model="filter.etapa">
                <option value="associacao">Associação</option>
                <option value="chegada">Chegada</option>
                <option value="encerramento">Encerramento</option>
              </select>
            </div>
            <div v-if="filter.etapa != 'associacao'" class="grid-12 column">
              <label for="data ">Data Inicio</label>
              <div class="date">
                <input type="date" placeholder="Data fim" v-model="filter.data_inicio"
                  @change="attendance({ etapa: filter.etapa, data_inicio: filter.data_inicio, data_fim: filter.data_fim })" />
              </div>
            </div>
            <div v-if="filter.etapa != 'associacao'" class="grid-12 column">
              <label for="data ">Data Fim</label>
              <div class="date">
                <input type="date" placeholder="Data fim" v-model="filter.data_fim"
                  @change="attendance({ etapa: filter.etapa, data_inicio: filter.data_inicio, data_fim: filter.data_fim })" />
              </div>
            </div>
            <div class="grid-12 column">
              <label for="gd">GD</label>
              <input type="text" placeholder="Digite" v-model="filter.gd" />
            </div>

            <div class="grid-12 column">
              <label>BU</label>
              <select class="input" v-model="filter.bu">
                <option value>Selecione</option>
                <option value="device">Device</option>
                <option value="digital">Digital</option>
                <option value="infraestrutura">Infraestrutura</option>
              </select>
            </div>
            <div class="grid-12 column">
              <label for="cliente">Cliente</label>
              <input type="text" placeholder="Digite" v-model="filter.cliente" />
            </div>

          <!--   <div class="grid-12 column">
              <label for="tipoAtendimento">Tipo atendimento</label>
              <select class="input" v-model="filter.tipoAtendimento">
                <option value>Tipo atendimento</option>
                <option value="atendimento">Avulso</option>
                <option value="alocacao">Alocação</option>
              </select>
            </div> -->
            <!-- <div class="grid-12 column">
              <label for="tolerancia">Tolerância (HH:MM)</label>
              <input type="time" class="input" name="tolerancia" v-model="filter.tolerancia" @change="
                attendance({ etapa: filter.etapa, tolerancia: filter.tolerancia })
                " />
            </div> -->
          </div>
        </div>
      </div>

      <!-- FILTRO DESKTOP -->
      <div class="title row column-s hide-s filter-desktop ac ja">
        <div class="grid-2 grid-12-s col">
          <label for="etapa">Etapa</label>
          <select class="input" name="etapa" @change="({ target: { value } }) => attendance({ etapa: value })"
            v-model="filter.etapa">
            <option value="associacao">Associação</option>
            <option value="chegada">Chegada</option>
            <option value="encerramento">Encerramento</option>
          </select>
        </div>
        <div v-if="filter.etapa != 'associacao'" class="grid-2 grid-12-s col">
          <label for="data ">Data Inicio</label>
          <div class="date">
            <input type="date" placeholder="Data fim" v-model="filter.data_inicio"
              @change="attendance({ etapa: filter.etapa, data_inicio: filter.data_inicio, data_fim: filter.data_fim })" />
          </div>
        </div>
        <div v-if="filter.etapa != 'associacao'" class="grid-2 grid-12-s">
          <label for="data ">Data Fim</label>
          <div class="date">
            <input type="date" placeholder="Data fim" v-model="filter.data_fim"
              @change="attendance({ etapa: filter.etapa, data_inicio: filter.data_inicio, data_fim: filter.data_fim })" />
          </div>
        </div>
        <div class="grid-2 grid-12-s col">
          <label for="gd">GD</label>
          <input type="text" placeholder="Digite" v-model="filter.gd" />
        </div>
        <div class="grid-2 grid-12-s col">
          <label for="bu">BU</label>
          <select class="input" name="bu" v-model="filter.bu">
            <option value>Selecione</option>
            <option value="device">Device</option>
            <option value="digital">Digital</option>
            <option value="infraestrutura">Infraestrutura</option>
          </select>
        </div>
        <div class="grid-2 grid-12-s col">
          <label for="cliente">Cliente</label>
          <input type="text" placeholder="Digite" v-model="filter.cliente" />
        </div>

     <!--    <div class="grid-2 grid-12-s col">
          <label for="tipoAtendimento">Tipo atendimento</label>
          <select class="input" nmae="tipoAtendimento" v-model="filter.tipoAtendimento">
            <option value>Selecione</option>
            <option value="atendimento">Avulso</option>
            <option value="alocacao">Alocação</option>
          </select>
        </div> -->
        <!-- <div class="grid-2-g grid-1-g grid-12-s">
          <label for="tolerancia">
            Tolerância
            <b v-if="!openMap">(HH:MM)</b>
          </label>
          <input type="time" class="input tolerancia" v-model="filter.tolerancia"
            @change="attendance({ etapa: filter.etapa, tolerancia: filter.tolerancia })" />
        </div> -->
      </div>

      <div class="content row wrap" v-if="!this.loader" @scroll="scrolled">
        <Table v-if="filter.etapa != 'associacao' && jobsFilter.length" :jobs="jobsFilter" :pager="pager"
          :map="openMarker" />
        <TableAssoc v-if="filter.etapa == 'associacao' && jobsFilter.length" :jobs="jobsFilter" :pager="pager"
          :map="openMarker" />
        <div v-if="!jobsFilter.length && !this.loader" class="jobs-empty grid-12 column align-center justify-center">
          <img src="../../assets/img/error.svg" alt="erro" />
          <div class="jobs-empty-text align-center column">
            <br />Você ainda não possui Jobs
            <br />
            <strong>nesta data</strong>
            <br />
            <br />
          </div>
        </div>
      </div>
      <div v-else class="cards-loader column align-center justify-center">
        <Loader />
      </div>
    </div>
    <div v-if="showMap" class="map" :class="openMap ? 'grid-7' : 'grid-1'">
      <div class="openMap hide-s" @click="
        openMap = !openMap;
      !openMap ? (card.show = false) : false;
      ">
        <i class="fa fa-chevron-left" v-if="!openMap"></i>
        &nbsp;
        {{ openMap ? "Fechar" : "Mapa" }} &nbsp;
        <i class="fa fa-chevron-right" v-if="openMap"></i>
      </div>
      <div class="openMap mobile" @click="
        showMap = false;
      card.show = false;
      ">
        &nbsp; Fechar &nbsp;
        <i class="fa fa-close"></i>
      </div>
      <gmap-map :center="center" :zoom="zoom" @click="openMap = true">
        <template v-for="(j, index) in jobsFilter">
          <gmap-polyline v-if="google &&
            index < pager &&
            j.status == 'Em trânsito' &&
            j.ultima_coordenada_doutor != null
          " :path="google.maps.geometry.encoding.decodePath(j.rota)" :options="{
            strokeColor: j.previsao_chegada_horario ? '#28BC9A' : '#FF5252',
            strokeOpacity: 1.0,
            strokeWeight: 6,
          }" :key="'path' + index"></gmap-polyline>
          <gmap-marker v-if="index < pager && j.status == 'Em trânsito' && j.ultima_coordenada_doutor
          " :position="{
            lat: Number(j.ultima_coordenada_doutor.split(',')[0]),
            lng: Number(j.ultima_coordenada_doutor.split(',')[1]),
          }" :icon="iconMap" :draggable="false" :key="'s' + index"></gmap-marker>
          <gmap-marker v-if="index < pager" :position="{ lat: j.latitude, lng: j.longitude }"
            @click="() => openMarker({ lat: j.latitude, lng: j.longitude }, j, true)" :draggable="false"
            :key="'m' + index"></gmap-marker>
        </template>
      </gmap-map>
    </div>

    <!-- CARD DO MAPA -->
    <Card class="card-map" :job="card.job" :class="card.show ? 'active' : ''" :map="false" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import Card from "@/components/Card.vue";
import Table from "@/components/TableAttendanceAdmin.vue";
import TableAssoc from "@/components/TableAttendanceAssoc.vue";
import IconMap from "@/statics/iconMap";
import * as VueGoogleMaps from "vue2-google-maps";
import { gmapApi } from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBb14nrVdCZh_uBI-wGkjjmB0ypHS4YInY",
    libraries: "geometry",
  },
});

// Casamento dos filtros digitados: sem texto, casa qualquer job; valor nulo não casa texto algum.
const contem = (valor, texto) => !texto || (valor || "").toLowerCase().includes(texto.toLowerCase());

export default {
  name: "Attendance",
  components: {
    Card,
    Loader,
    Table,
    TableAssoc
  },
  data() {
    return {
      gds: [],
      jobs: [],
      iconMap: IconMap,
      pager: 20,
      gd: "",
      openMap: false,
      filters: false,
      loader: true,
      showMap: window.innerWidth > 850 ? true : false,
      filter: {
        data_inicio: new Date().toISOString().slice(0, 10),
        data_fim: new Date().toISOString().slice(0, 10),
        bu: "",
        gd: "",
        cliente: "",
        tipoAtendimento: "",
        etapa: "associacao",
      },
      card: { job: {}, x: "0px", y: "0px", show: false },
      center: { lat: -15.0575488, lng: -54.247716 },
      zoom: 5,
    };
  },
  methods: {
    ...mapActions("jobs", ["LOAD_ATTENDANCE"]),
    ...mapActions("client", ["LOAD_CLIENT_CLIENT", "LOAD_TYPE_SERVICES"]),
    ...mapActions("admin", ["FUNCIONARIO_LIST", "JOB_ASSOC"]),
    getGD() {
      this.FUNCIONARIO_LIST({ status: 'ativo', id_grupo: 3 }).then(({ data }) => this.gds = data)
    },
    openMarker(marker, job, card) {
      this.card.show = false;
      this.center = marker;
      this.card.job = job;
      if (this.openMap && card && this.zoom == 14) {
        let offY = job.id_doutor ? 100 : 400;
        this.card.x = (event.pageX || event.changedTouches[0].pageX) - 190 + "px";
        this.card.y = (event.pageY || event.changedTouches[0].pageY) - offY + "px";
        this.card.show = true;
      }
      this.zoom = 13;
      this.openMap = true;
      this.showMap = true;
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    scrolled(event) {
      if (
        event.target.offsetHeight + event.target.scrollTop ==
        event.target.scrollHeight
      ) {
        this.pager += 9;
      }
    },
    tipo(t) {
      if (!this.filter.tipoAtendimento) return true;
      return t == this.filter.tipoAtendimento ? true : false;
    },
    // A ação resolve com o erro do axios quando a rota falha (404 sem registros, por exemplo), e
    // ele não traz `data`: a lista fica vazia em vez de indefinida.
    recebeJobs({ data }) {
      this.jobs = Array.isArray(data) ? data : [];
      this.loader = false;
    },
    attendance(filter) {
      this.loader = true
      if (filter.etapa != 'associacao') {
        if (!filter.tolerancia) filter.tolerancia = "00:00";
        if (!this.filter.data_inicio.length) delete filter.data_inicio
        if (!this.filter.data_fim.length) delete filter.data_fim
        this.LOAD_ATTENDANCE({ etapa: filter.etapa, data_inicio: this.filter.data_inicio, data_fim: this.filter.data_fim, ...filter }).then(this.recebeJobs).catch(() => this.loader = false);
      } else this.JOB_ASSOC().then(this.recebeJobs).catch(() => { this.loader = false; this.jobs = [] })

    },
  },
  beforeMount() {
    this.attendance({ etapa: this.filter.etapa });
    this.getGD()
  },
  mounted() {
    this.LOAD_TYPE_SERVICES();
    this.$parent.$children[0].changeMenu("attendance");
  },
  computed: {
    ...mapGetters("client", ["type_services"]),
    ...mapGetters("user", ["user"]),
    google: gmapApi,
    // BU, GD e Cliente combinam por E: o job só fica se casar com todos os filtros preenchidos.
    jobsFilter() {
      const { bu, gd, cliente } = this.filter;
      return this.jobs.filter((job) =>
        (!bu || job.unidade_negocio === bu) && contem(job.gd, gd) && contem(job.cliente, cliente)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.attendance {
  height: 92.5vh;

  .cards {
    background: $white-2;
    overflow: auto;

    @media (min-width: $small) {
      border-right: 2px solid $white-1;
    }

    .title {
      letter-spacing: -0.26px;
      color: $black;
      font-size: 26px;

      span {
        color: $purple;
        font-weight: bold;
        margin-left: 5px;
        font-size: 16px;
      }

      label {
        font-weight: bold;
        font-size: 13px;
        color: $purple;
        margin-bottom: 4px
      }

      @media (min-width: $small) {
        padding-left: 70px;
        padding-top: 50px;
      }

      @media (max-width: $small) {
        padding: 30px 20px;
      }
    }

    .date {
      input {
        @media (max-width: $small) {
          width: 92%;
        }
      }

      height: 35px;

    }

    .search {
      margin-right: 20px;
      padding-right: 20px;
      height: 35px;
      border-bottom: 1px solid $white-4;

      @media (max-width: $small) {
        margin-bottom: 25px;
        margin-right: 30px;
      }

      input {
        border: none;
        padding: 5px 7px;
        background: white;

        @media (max-width: $small) {
          width: 92%;
        }
      }
    }

    .list {
      margin-right: 50px;

      i {
        color: $gray-9;
        width: 35px;
        height: 35px;
        border-radius: 4px;
        text-align: center;
        line-height: 38px;
        font-size: 25px;
        margin-right: 7px;

        &:hover {
          cursor: pointer;
          background: $green-2;
          color: $white;
          opacity: 0.7;
        }
      }

      .active {
        background: $white-1;
        color: $white;
      }
    }

    .status {
      margin-top: 50px;
      font-size: 15px;
      color: $gray-10;
      padding-right: 65px;
      border-bottom: 1px solid $white-1;
      padding-left: 70px;
      min-width: 800px;

      @media (max-width: $small) {
        padding-left: 25px;
        margin-top: 25px;
      }

      &-mask {
        overflow: auto;
        height: 200px;
      }

      &-container {
        overflow: hidden;
        height: 150px;
      }

      li {
        padding-bottom: 10px;
        cursor: pointer;

        &:hover {
          color: $green-1;
          border-bottom: 3px solid $green-1;
        }
      }

      .active {
        color: $green-10;
        border-bottom: 3px solid $green-10;
      }
    }

    &-loader {
      margin-top: 15%;
    }

    .content {
      padding-left: 70px;
      padding-top: 0px;
      padding-bottom: 70px;
      height: 100%;
      overflow: auto;
      /*  margin-right: 50px; */
      margin-top: 25px;

      @media (max-width: $small) {
        height: 100vh;
        padding-left: 20px;
        margin-top: 10px;
        padding-top: 0px;
      }
    }
  }

  .vue-map-container {
    width: 100%;
    height: 100%;
  }

  .openMap {
    background: $white-2 0% 0% no-repeat padding-box;
    border: 2px solid $white-1;
    border-left: none;
    border-radius: 0px 17px 17px 0px;
    font-size: 15px;
    color: $gray-2;
    width: 90px;
    cursor: pointer;
    position: absolute;
    bottom: 50px;
    z-index: 791;
    padding: 12px 15px;
    font-weight: bold;

    &.mobile {
      display: none;
      background: $gray-1 0% 0% no-repeat padding-box;
      color: $white;

      @media (max-width: $small) {
        display: block;
        position: fixed;
        bottom: 50px;
      }
    }
  }

  input[type="time"] {
    border: 1px solid $white-6 !important;
    background: white;
    width: 93%;
    height: 41px;
  }

  .filter-desktop {
    padding-right: 70px;
    padding-top: 14px !important;
  }

  .filters {
    input {
      color: $gray-5;
      font-weight: bold;
    }

    @media (max-width: $small) {
      padding-top: 0px;
      padding-left: 20px;
      margin-bottom: 25px;
    }

    @media (max-width: $large) {
      margin-top: 30px;
    }

    .grid-12 {
      margin-top: 20px;
    }
  }

  .filters-mobile {
    i {
      border-radius: 50%;
      color: $gray-2;
      width: 45px;
      height: 45px;
      text-align: center;
      line-height: 46px;
    }
  }

  .opened {
    .card {
      width: 100%;
    }

    .status {
      &-container {
        height: 170px;
      }
    }

    .filters {
      @media (min-width: $small) {
        margin-top: 30px;
        width: 100%;
        margin-left: 70px;
        flex-direction: column;

        margin-left: 70px;

        .search,
        .date,
        .list {
          margin-top: 20px;
        }

        .search input {
          width: 90%;
        }

        .date input {
          width: 45%;
        }
      }
    }

    .content {
      margin-right: 0px;
    }
  }

  .card-map {
    position: fixed;
    width: 327px;
    right: 17%;
    bottom: -400px;

    &.active {
      bottom: 0px;
      right: 17%;

      @media (max-width: $small) {
        left: 2%;
        bottom: 120px;
      }
    }
  }

  .map {
    @media (max-width: $small) {
      /* display: none; */
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0px;
      /*  z-index: 999; */
    }
  }

}
</style>
